import BaseExecutor from 'services/sports/default/base-executor';
import BaseValidator from 'services/validations/base-validator';
import {ClassicValidatorBuilder} from 'services/validations/builders/classic-validator-builder';
import {RandomTeamStackingValidatorBuilder} from 'services/sports/lol/validator/random-team-stacking-validator-builder';

export default class UserAdjustmentsValidatorClassicBuilder extends BaseExecutor {
    getInterface() {
        const validator = new BaseValidator();

        const classicValidatorBuilder = new ClassicValidatorBuilder().getInterface();
        validator.addSubValidators([classicValidatorBuilder]);

        const randomTeamStackingValidatorBuilder = new RandomTeamStackingValidatorBuilder().getInterface();
        validator.addSubValidators([randomTeamStackingValidatorBuilder]);

        return validator;
    }
}
